import CanvasBase from "./CanvasBase";
import React from "react";
import pitch from '../../../assets/img/demo/ils-field@3x.png';

class PitchCanvas extends CanvasBase {
    constructor(props) {
        super(props);
        this.handlePithLoaded = this.handlePithLoaded.bind(this);
        this.handleCanvasBackgroundLoaded = this.handleCanvasBackgroundLoaded.bind(this);
    }

    componentDidMount() {
        this.initPitch();
    }

    canvasBackground() {
        return this.pithImage();
    }

    initPitch() {
        this.initBackground();
    }

    handleCanvasBackgroundLoaded() {
        if (typeof this.handlePithLoaded === 'function')
            this.handlePithLoaded();
    }

    handlePithLoaded() {
    }

    pithImage = () => pitch;
}


const positions = {
    CM: {x: 0, y: 0},
    LM: {x: -0.691666666666667, y: 0},
    RM: {x: 0.691666666666667, y: 0},
    AM: {x: 0, y: 0.227272727272727},
    DM: {x: 0, y: -0.227272727272727},
    SS: {x: 0, y: 0.539772727272728},
    CB: {x: 0, y: -0.539772727272728},
    CF: {x: 0, y: 0.738636363636364},
    SW: {x: 0, y: -0.738636363636364},
    GK: {x: 0, y: -0.931818181818182},
    LW: {x: -0.691666666666667, y: 0.539772727272728},
    RW: {x: 0.691666666666667, y: 0.539772727272728},
    LB: {x: -0.691666666666667, y: -0.539772727272728},
    RB: {x: 0.691666666666667, y: -0.539772727272728},
    LWB: {x: -0.691666666666667, y: -0.335227272727273},
    RWB: {x: 0.691666666666667, y: -0.335227272727273},
};

const tempPositions = {
    CM: [
        [
            510,
            675,
            1
        ],
        [
            505,
            675,
            1
        ],
        [
            500,
            675,
            1
        ],
        [
            495,
            665,
            1
        ],
        [
            485,
            650,
            1
        ],
        [
            515,
            660,
            1
        ],
        [
            510,
            660,
            1
        ],
        [
            505,
            650,
            1
        ],
        [
            505,
            650,
            1
        ],
        [
            515,
            680,
            1
        ],
        [
            515,
            685,
            1
        ],
        [
            515,
            685,
            1
        ],
        [
            515,
            685,
            1
        ],
        [
            505,
            680,
            1
        ],
        [
            505,
            675,
            1
        ],
        [
            505,
            670,
            1
        ],
        [
            505,
            670,
            1
        ],
        [
            505,
            670,
            1
        ],
        [
            510,
            660,
            1
        ],
        [
            510,
            655,
            1
        ],
        [
            510,
            650,
            1
        ],
        [
            515,
            650,
            1
        ],
        [
            515,
            650,
            1
        ],
        [
            515,
            650,
            1
        ],
        [
            525,
            650,
            1
        ],
        [
            540,
            650,
            1
        ],
        [
            545,
            640,
            1
        ],
        [
            545,
            640,
            1
        ],
        [
            550,
            625,
            1
        ],
        [
            550,
            625,
            1
        ],
        [
            550,
            625,
            1
        ],
        [
            555,
            620,
            1
        ],
        [
            555,
            620,
            1
        ],
        [
            555,
            615,
            1
        ],
        [
            565,
            610,
            1
        ],
        [
            565,
            605,
            1
        ],
        [
            575,
            600,
            1
        ],
        [
            580,
            590,
            1
        ],
        [
            580,
            580,
            1
        ],
        [
            580,
            580,
            1
        ],
        [
            585,
            580,
            1
        ],
        [
            610,
            540,
            1
        ],
        [
            605,
            550,
            1
        ],
        [
            605,
            550,
            1
        ],
        [
            605,
            550,
            1
        ],
        [
            595,
            560,
            1
        ],
        [
            585,
            575,
            1
        ],
        [
            585,
            575,
            1
        ],
        [
            575,
            585,
            1
        ],
        [
            525,
            570,
            1
        ],
        [
            510,
            565,
            1
        ],
        [
            510,
            565,
            1
        ],
        [
            510,
            560,
            1
        ],
        [
            515,
            560,
            1
        ],
        [
            515,
            560,
            1
        ],
        [
            520,
            560,
            1
        ],
        [
            530,
            560,
            1
        ],
        [
            530,
            565,
            1
        ],
        [
            535,
            570,
            1
        ],
        [
            535,
            570,
            1
        ],
        [
            535,
            570,
            1
        ],
        [
            580,
            610,
            1
        ],
        [
            580,
            615,
            1
        ],
        [
            585,
            615,
            1
        ],
        [
            600,
            645,
            1
        ],
        [
            610,
            665,
            1
        ],
        [
            610,
            670,
            1
        ],
        [
            615,
            680,
            1
        ],
        [
            615,
            685,
            1
        ],
        [
            615,
            685,
            1
        ],
        [
            615,
            685,
            1
        ],
        [
            615,
            700,
            1
        ],
        [
            615,
            700,
            1
        ],
        [
            615,
            705,
            1
        ],
        [
            610,
            710,
            1
        ],
        [
            615,
            725,
            1
        ],
        [
            635,
            685,
            1
        ],
        [
            635,
            690,
            1
        ],
        [
            635,
            690,
            1
        ],
        [
            635,
            690,
            1
        ],
        [
            635,
            690,
            1
        ],
        [
            625,
            695,
            1
        ],
        [
            620,
            735,
            1
        ],
        [
            620,
            735,
            1
        ],
        [
            620,
            735,
            1
        ],
        [
            620,
            755,
            1
        ],
        [
            620,
            760,
            1
        ],
        [
            625,
            760,
            1
        ],
        [
            470,
            535,
            1
        ],
        [
            470,
            535,
            1
        ],
        [
            465,
            535,
            1
        ],
        [
            465,
            535,
            1
        ],
        [
            455,
            530,
            1
        ],
        [
            445,
            525,
            1
        ],
        [
            435,
            525,
            1
        ],
        [
            430,
            525,
            1
        ],
        [
            430,
            520,
            1
        ],
        [
            555,
            460,
            1
        ],
        [
            555,
            465,
            1
        ],
        [
            575,
            450,
            1
        ],
        [
            575,
            450,
            1
        ],
        [
            585,
            460,
            1
        ],
        [
            590,
            460,
            1
        ],
        [
            620,
            505,
            1
        ],
        [
            625,
            505,
            1
        ],
        [
            625,
            505,
            1
        ],
        [
            650,
            510,
            1
        ],
        [
            655,
            510,
            1
        ],
        [
            655,
            510,
            1
        ],
        [
            605,
            435,
            1
        ],
        [
            605,
            435,
            1
        ],
        [
            645,
            430,
            1
        ],
        [
            645,
            430,
            1
        ],
        [
            665,
            450,
            1
        ],
        [
            665,
            450,
            1
        ],
        [
            680,
            445,
            1
        ],
        [
            685,
            445,
            1
        ],
        [
            685,
            470,
            1
        ],
        [
            685,
            470,
            1
        ],
        [
            685,
            470,
            1
        ],
        [
            690,
            470,
            1
        ]
    ],
    LM: [
        [
            135,
            670,
            1
        ],
        [
            135,
            670,
            1
        ],
        [
            140,
            670,
            1
        ],
        [
            140,
            670,
            1
        ],
        [
            145,
            660,
            1
        ],
        [
            145,
            655,
            1
        ],
        [
            145,
            655,
            1
        ],
        [
            145,
            655,
            1
        ],
        [
            145,
            650,
            1
        ],
        [
            160,
            630,
            1
        ],
        [
            165,
            610,
            1
        ],
        [
            170,
            605,
            1
        ],
        [
            175,
            600,
            1
        ],
        [
            240,
            560,
            1
        ],
        [
            240,
            560,
            1
        ],
        [
            240,
            560,
            1
        ],
        [
            240,
            560,
            1
        ],
        [
            235,
            560,
            1
        ],
        [
            230,
            575,
            1
        ],
        [
            220,
            580,
            1
        ],
        [
            170,
            690,
            1
        ],
        [
            170,
            690,
            1
        ],
        [
            170,
            690,
            1
        ],
        [
            175,
            690,
            1
        ],
        [
            175,
            690,
            1
        ],
        [
            190,
            700,
            1
        ],
        [
            190,
            700,
            1
        ],
        [
            190,
            700,
            1
        ],
        [
            205,
            710,
            1
        ],
        [
            205,
            710,
            1
        ],
        [
            215,
            715,
            1
        ],
        [
            215,
            715,
            1
        ],
        [
            215,
            715,
            1
        ],
        [
            225,
            730,
            1
        ],
        [
            240,
            745,
            1
        ],
        [
            240,
            750,
            1
        ],
        [
            240,
            750,
            1
        ],
        [
            240,
            750,
            1
        ],
        [
            240,
            750,
            1
        ],
        [
            245,
            760,
            1
        ],
        [
            80,
            665,
            1
        ],
        [
            110,
            635,
            1
        ],
        [
            110,
            635,
            1
        ],
        [
            110,
            635,
            1
        ],
        [
            110,
            630,
            1
        ],
        [
            155,
            550,
            1
        ],
        [
            155,
            550,
            1
        ],
        [
            155,
            545,
            1
        ],
        [
            155,
            545,
            1
        ],
        [
            160,
            545,
            1
        ],
        [
            160,
            545,
            1
        ],
        [
            160,
            540,
            1
        ],
        [
            165,
            540,
            1
        ],
        [
            165,
            535,
            1
        ],
        [
            165,
            535,
            1
        ],
        [
            165,
            530,
            1
        ],
        [
            195,
            465,
            1
        ],
        [
            200,
            465,
            1
        ],
        [
            200,
            465,
            1
        ],
        [
            200,
            465,
            1
        ],
        [
            200,
            465,
            1
        ],
        [
            200,
            460,
            1
        ],
        [
            200,
            455,
            1
        ],
        [
            200,
            455,
            1
        ],
        [
            200,
            455,
            1
        ],
        [
            205,
            450,
            1
        ],
        [
            215,
            410,
            1
        ],
        [
            235,
            675,
            1
        ],
        [
            235,
            675,
            1
        ],
        [
            245,
            670,
            1
        ],
        [
            255,
            640,
            1
        ],
        [
            255,
            640,
            1
        ],
        [
            255,
            640,
            1
        ],
        [
            290,
            585,
            1
        ],
        [
            290,
            585,
            1
        ],
        [
            290,
            585,
            1
        ],
        [
            290,
            585,
            1
        ],
        [
            290,
            580,
            1
        ],
        [
            300,
            565,
            1
        ],
        [
            195,
            690,
            1
        ],
        [
            195,
            685,
            1
        ],
        [
            190,
            685,
            1
        ],
        [
            190,
            685,
            1
        ],
        [
            185,
            685,
            1
        ],
        [
            180,
            680,
            1
        ],
        [
            180,
            680,
            1
        ],
        [
            180,
            685,
            1
        ],
        [
            195,
            690,
            1
        ],
        [
            195,
            695,
            1
        ],
        [
            200,
            705,
            1
        ],
        [
            210,
            550,
            1
        ],
        [
            220,
            595,
            1
        ],
        [
            220,
            600,
            1
        ],
        [
            220,
            600,
            1
        ],
        [
            220,
            700,
            1
        ],
        [
            215,
            730,
            1
        ]
    ],
    RM: [
        [
            770,
            650,
            1
        ],
        [
            770,
            650,
            1
        ],
        [
            775,
            645,
            1
        ],
        [
            810,
            570,
            1
        ],
        [
            810,
            570,
            1
        ],
        [
            810,
            565,
            1
        ],
        [
            815,
            565,
            1
        ],
        [
            815,
            560,
            1
        ],
        [
            815,
            555,
            1
        ],
        [
            815,
            550,
            1
        ],
        [
            820,
            550,
            1
        ],
        [
            820,
            545,
            1
        ],
        [
            820,
            545,
            1
        ],
        [
            840,
            510,
            1
        ],
        [
            870,
            405,
            1
        ],
        [
            870,
            410,
            1
        ],
        [
            860,
            535,
            1
        ],
        [
            860,
            540,
            1
        ],
        [
            850,
            655,
            1
        ],
        [
            835,
            590,
            1
        ],
        [
            835,
            595,
            1
        ],
        [
            835,
            595,
            1
        ],
        [
            830,
            615,
            1
        ],
        [
            805,
            560,
            1
        ],
        [
            805,
            560,
            1
        ],
        [
            720,
            480,
            1
        ],
        [
            715,
            475,
            1
        ],
        [
            710,
            470,
            1
        ],
        [
            705,
            470,
            1
        ],
        [
            700,
            465,
            1
        ],
        [
            695,
            460,
            1
        ],
        [
            690,
            455,
            1
        ],
        [
            670,
            445,
            1
        ],
        [
            665,
            445,
            1
        ],
        [
            660,
            440,
            1
        ],
        [
            615,
            410,
            1
        ],
        [
            645,
            475,
            1
        ],
        [
            710,
            580,
            1
        ],
        [
            715,
            590,
            1
        ],
        [
            720,
            595,
            1
        ],
        [
            725,
            600,
            1
        ],
        [
            820,
            775,
            1
        ],
        [
            640,
            525,
            1
        ],
        [
            640,
            525,
            1
        ],
        [
            645,
            525,
            1
        ],
        [
            645,
            525,
            1
        ],
        [
            645,
            525,
            1
        ],
        [
            650,
            525,
            1
        ],
        [
            805,
            660,
            1
        ],
        [
            810,
            670,
            1
        ],
        [
            815,
            680,
            1
        ],
        [
            820,
            685,
            1
        ],
        [
            825,
            695,
            1
        ],
        [
            835,
            700,
            1
        ],
        [
            840,
            710,
            1
        ],
        [
            845,
            720,
            1
        ],
        [
            890,
            820,
            1
        ],
        [
            710,
            540,
            1
        ],
        [
            710,
            540,
            1
        ],
        [
            715,
            545,
            1
        ],
        [
            720,
            545,
            1
        ],
        [
            720,
            545,
            1
        ],
        [
            725,
            550,
            1
        ],
        [
            725,
            550,
            1
        ],
        [
            765,
            610,
            1
        ],
        [
            790,
            660,
            1
        ],
        [
            775,
            585,
            1
        ],
        [
            835,
            685,
            1
        ],
        [
            840,
            695,
            1
        ],
        [
            930,
            840,
            1
        ],
        [
            745,
            575,
            1
        ],
        [
            750,
            575,
            1
        ],
        [
            790,
            650,
            1
        ],
        [
            790,
            685,
            1
        ],
        [
            790,
            685,
            1
        ],
        [
            785,
            725,
            1
        ],
        [
            780,
            730,
            1
        ],
        [
            780,
            730,
            1
        ],
        [
            780,
            735,
            1
        ],
        [
            720,
            645,
            1
        ],
        [
            720,
            645,
            1
        ],
        [
            720,
            645,
            1
        ],
        [
            725,
            645,
            1
        ],
        [
            725,
            645,
            1
        ],
        [
            730,
            645,
            1
        ],
        [
            730,
            645,
            1
        ],
        [
            750,
            655,
            1
        ],
        [
            755,
            670,
            1
        ]
    ],
    AM: [
        [
            495,
            505,
            1
        ],
        [
            495,
            505,
            1
        ],
        [
            505,
            505,
            1
        ],
        [
            505,
            505,
            1
        ],
        [
            505,
            505,
            1
        ],
        [
            505,
            505,
            1
        ],
        [
            510,
            505,
            1
        ],
        [
            510,
            505,
            1
        ],
        [
            510,
            505,
            1
        ],
        [
            510,
            505,
            1
        ],
        [
            510,
            505,
            1
        ],
        [
            510,
            505,
            1
        ],
        [
            515,
            505,
            1
        ],
        [
            510,
            505,
            1
        ],
        [
            515,
            500,
            1
        ],
        [
            515,
            500,
            1
        ],
        [
            520,
            500,
            1
        ],
        [
            520,
            500,
            1
        ],
        [
            520,
            500,
            1
        ],
        [
            520,
            500,
            1
        ],
        [
            545,
            495,
            1
        ],
        [
            545,
            495,
            1
        ],
        [
            590,
            495,
            1
        ],
        [
            595,
            495,
            1
        ],
        [
            620,
            490,
            1
        ],
        [
            620,
            490,
            1
        ],
        [
            625,
            490,
            1
        ],
        [
            630,
            490,
            1
        ],
        [
            620,
            490,
            1
        ],
        [
            620,
            490,
            1
        ],
        [
            620,
            490,
            1
        ],
        [
            620,
            490,
            1
        ],
        [
            635,
            495,
            1
        ],
        [
            650,
            495,
            1
        ],
        [
            655,
            495,
            1
        ],
        [
            655,
            495,
            1
        ],
        [
            655,
            495,
            1
        ],
        [
            680,
            485,
            1
        ],
        [
            680,
            485,
            1
        ],
        [
            685,
            485,
            1
        ],
        [
            685,
            485,
            1
        ],
        [
            685,
            485,
            1
        ],
        [
            685,
            480,
            1
        ],
        [
            685,
            480,
            1
        ],
        [
            685,
            480,
            1
        ],
        [
            690,
            480,
            1
        ],
        [
            690,
            480,
            1
        ],
        [
            720,
            460,
            1
        ],
        [
            460,
            555,
            1
        ],
        [
            460,
            555,
            1
        ],
        [
            460,
            555,
            1
        ],
        [
            460,
            555,
            1
        ],
        [
            455,
            555,
            1
        ],
        [
            515,
            575,
            1
        ],
        [
            515,
            575,
            1
        ],
        [
            515,
            575,
            1
        ],
        [
            515,
            575,
            1
        ],
        [
            520,
            575,
            1
        ],
        [
            525,
            580,
            1
        ],
        [
            525,
            580,
            1
        ],
        [
            525,
            580,
            1
        ],
        [
            530,
            585,
            1
        ],
        [
            580,
            610,
            1
        ],
        [
            580,
            610,
            1
        ],
        [
            620,
            595,
            1
        ],
        [
            620,
            595,
            1
        ],
        [
            615,
            595,
            1
        ],
        [
            610,
            600,
            1
        ],
        [
            585,
            610,
            1
        ],
        [
            585,
            610,
            1
        ],
        [
            580,
            610,
            1
        ],
        [
            580,
            615,
            1
        ],
        [
            580,
            615,
            1
        ],
        [
            625,
            625,
            1
        ],
        [
            625,
            625,
            1
        ],
        [
            630,
            625,
            1
        ],
        [
            635,
            625,
            1
        ],
        [
            655,
            640,
            1
        ],
        [
            655,
            640,
            1
        ],
        [
            660,
            640,
            1
        ],
        [
            565,
            550,
            1
        ],
        [
            565,
            550,
            1
        ],
        [
            570,
            555,
            1
        ],
        [
            630,
            545,
            1
        ],
        [
            630,
            545,
            1
        ],
        [
            630,
            545,
            1
        ],
        [
            630,
            545,
            1
        ],
        [
            635,
            545,
            1
        ],
        [
            430,
            515,
            1
        ],
        [
            425,
            510,
            1
        ],
        [
            460,
            475,
            1
        ],
        [
            460,
            475,
            1
        ],
        [
            455,
            475,
            1
        ],
        [
            455,
            475,
            1
        ],
        [
            455,
            475,
            1
        ],
        [
            455,
            475,
            1
        ],
        [
            450,
            470,
            1
        ],
        [
            450,
            470,
            1
        ],
        [
            450,
            465,
            1
        ]
    ],
    DM: [
        [
            490,
            805,
            1
        ],
        [
            480,
            815,
            1
        ],
        [
            480,
            815,
            1
        ],
        [
            480,
            815,
            1
        ],
        [
            480,
            815,
            1
        ],
        [
            480,
            815,
            1
        ],
        [
            480,
            815,
            1
        ],
        [
            480,
            820,
            1
        ],
        [
            475,
            820,
            1
        ],
        [
            475,
            820,
            1
        ],
        [
            465,
            830,
            1
        ],
        [
            465,
            830,
            1
        ],
        [
            465,
            830,
            1
        ],
        [
            460,
            830,
            1
        ],
        [
            460,
            830,
            1
        ],
        [
            460,
            830,
            1
        ],
        [
            460,
            830,
            1
        ],
        [
            460,
            830,
            1
        ],
        [
            460,
            830,
            1
        ],
        [
            460,
            830,
            1
        ],
        [
            455,
            835,
            1
        ],
        [
            455,
            835,
            1
        ],
        [
            455,
            835,
            1
        ],
        [
            450,
            835,
            1
        ],
        [
            450,
            835,
            1
        ],
        [
            450,
            835,
            1
        ],
        [
            450,
            835,
            1
        ],
        [
            450,
            835,
            1
        ],
        [
            445,
            835,
            1
        ],
        [
            445,
            835,
            1
        ],
        [
            425,
            840,
            1
        ],
        [
            425,
            840,
            1
        ],
        [
            425,
            840,
            1
        ],
        [
            550,
            860,
            1
        ],
        [
            555,
            860,
            1
        ],
        [
            560,
            855,
            1
        ],
        [
            560,
            855,
            1
        ],
        [
            560,
            855,
            1
        ],
        [
            570,
            860,
            1
        ],
        [
            575,
            860,
            1
        ],
        [
            575,
            860,
            1
        ],
        [
            590,
            865,
            1
        ],
        [
            680,
            815,
            1
        ],
        [
            680,
            815,
            1
        ],
        [
            675,
            820,
            1
        ],
        [
            605,
            805,
            1
        ],
        [
            605,
            805,
            1
        ],
        [
            625,
            795,
            1
        ],
        [
            630,
            795,
            1
        ],
        [
            630,
            795,
            1
        ],
        [
            630,
            795,
            1
        ],
        [
            630,
            795,
            1
        ],
        [
            645,
            780,
            1
        ],
        [
            645,
            780,
            1
        ],
        [
            655,
            775,
            1
        ],
        [
            655,
            775,
            1
        ],
        [
            625,
            895,
            1
        ],
        [
            625,
            895,
            1
        ],
        [
            625,
            895,
            1
        ],
        [
            625,
            895,
            1
        ],
        [
            630,
            900,
            1
        ],
        [
            545,
            860,
            1
        ],
        [
            545,
            860,
            1
        ],
        [
            545,
            865,
            1
        ],
        [
            545,
            865,
            1
        ],
        [
            545,
            865,
            1
        ],
        [
            545,
            865,
            1
        ],
        [
            540,
            870,
            1
        ],
        [
            450,
            930,
            1
        ],
        [
            450,
            930,
            1
        ],
        [
            435,
            930,
            1
        ],
        [
            435,
            930,
            1
        ],
        [
            435,
            935,
            1
        ],
        [
            430,
            935,
            1
        ],
        [
            430,
            935,
            1
        ],
        [
            430,
            935,
            1
        ],
        [
            410,
            940,
            1
        ],
        [
            395,
            935,
            1
        ],
        [
            395,
            935,
            1
        ],
        [
            395,
            935,
            1
        ],
        [
            395,
            935,
            1
        ],
        [
            380,
            930,
            1
        ],
        [
            370,
            925,
            1
        ],
        [
            370,
            925,
            1
        ],
        [
            365,
            925,
            1
        ],
        [
            340,
            975,
            1
        ],
        [
            340,
            975,
            1
        ],
        [
            330,
            990,
            1
        ],
        [
            315,
            1000,
            1
        ],
        [
            315,
            1000,
            1
        ],
        [
            300,
            1015,
            1
        ],
        [
            285,
            950,
            1
        ],
        [
            285,
            950,
            1
        ],
        [
            290,
            905,
            1
        ],
        [
            290,
            905,
            1
        ],
        [
            290,
            905,
            1
        ],
        [
            290,
            900,
            1
        ],
        [
            290,
            900,
            1
        ],
        [
            290,
            900,
            1
        ],
        [
            290,
            900,
            1
        ],
        [
            290,
            900,
            1
        ],
        [
            290,
            895,
            1
        ],
        [
            290,
            895,
            1
        ],
        [
            290,
            895,
            1
        ],
        [
            290,
            895,
            1
        ],
        [
            295,
            885,
            1
        ],
        [
            495,
            945,
            1
        ],
        [
            495,
            945,
            1
        ],
        [
            500,
            960,
            1
        ],
        [
            500,
            965,
            1
        ],
        [
            500,
            965,
            1
        ],
        [
            500,
            975,
            1
        ],
        [
            530,
            995,
            1
        ],
        [
            530,
            995,
            1
        ],
        [
            535,
            1025,
            1
        ],
        [
            535,
            1030,
            1
        ],
        [
            540,
            1030,
            1
        ],
        [
            540,
            1030,
            1
        ],
        [
            540,
            1035,
            1
        ],
        [
            555,
            950,
            1
        ],
        [
            555,
            950,
            1
        ],
        [
            555,
            945,
            1
        ],
        [
            685,
            910,
            1
        ],
        [
            685,
            915,
            1
        ],
        [
            690,
            915,
            1
        ],
        [
            690,
            920,
            1
        ],
        [
            730,
            880,
            1
        ],
        [
            730,
            880,
            1
        ],
        [
            730,
            880,
            1
        ],
        [
            730,
            880,
            1
        ],
        [
            730,
            880,
            1
        ],
        [
            730,
            885,
            1
        ],
        [
            730,
            885,
            1
        ],
        [
            735,
            885,
            1
        ],
        [
            735,
            885,
            1
        ],
        [
            735,
            885,
            1
        ],
        [
            745,
            885,
            1
        ],
        [
            770,
            920,
            1
        ]
    ],
    SS: [
        [
            475,
            375,
            1
        ],
        [
            475,
            375,
            1
        ],
        [
            460,
            385,
            1
        ],
        [
            460,
            385,
            1
        ],
        [
            460,
            385,
            1
        ],
        [
            440,
            410,
            1
        ],
        [
            440,
            410,
            1
        ],
        [
            440,
            410,
            1
        ],
        [
            435,
            410,
            1
        ],
        [
            435,
            415,
            1
        ],
        [
            435,
            415,
            1
        ],
        [
            435,
            415,
            1
        ],
        [
            435,
            420,
            1
        ],
        [
            525,
            435,
            1
        ],
        [
            525,
            435,
            1
        ],
        [
            575,
            400,
            1
        ],
        [
            575,
            400,
            1
        ],
        [
            580,
            400,
            1
        ],
        [
            620,
            370,
            1
        ],
        [
            545,
            385,
            1
        ],
        [
            545,
            385,
            1
        ],
        [
            560,
            345,
            1
        ],
        [
            560,
            340,
            1
        ],
        [
            560,
            340,
            1
        ],
        [
            580,
            295,
            1
        ],
        [
            585,
            290,
            1
        ],
        [
            515,
            370,
            1
        ],
        [
            515,
            370,
            1
        ],
        [
            515,
            370,
            1
        ],
        [
            515,
            365,
            1
        ],
        [
            515,
            365,
            1
        ],
        [
            515,
            365,
            1
        ],
        [
            515,
            320,
            1
        ],
        [
            515,
            320,
            1
        ],
        [
            515,
            315,
            1
        ],
        [
            530,
            285,
            1
        ],
        [
            560,
            425,
            1
        ],
        [
            565,
            425,
            1
        ],
        [
            600,
            420,
            1
        ],
        [
            600,
            420,
            1
        ],
        [
            605,
            420,
            1
        ],
        [
            605,
            420,
            1
        ],
        [
            605,
            420,
            1
        ],
        [
            610,
            420,
            1
        ],
        [
            450,
            365,
            1
        ],
        [
            450,
            365,
            1
        ],
        [
            400,
            320,
            1
        ],
        [
            315,
            275,
            1
        ],
        [
            340,
            300,
            1
        ],
        [
            340,
            300,
            1
        ],
        [
            370,
            265,
            1
        ],
        [
            440,
            155,
            1
        ],
        [
            445,
            150,
            1
        ],
        [
            445,
            150,
            1
        ],
        [
            450,
            145,
            1
        ],
        [
            455,
            140,
            1
        ],
        [
            460,
            135,
            1
        ],
        [
            465,
            135,
            1
        ],
        [
            465,
            130,
            1
        ],
        [
            470,
            125,
            1
        ],
        [
            515,
            300,
            1
        ],
        [
            515,
            305,
            1
        ],
        [
            525,
            355,
            1
        ],
        [
            555,
            185,
            1
        ],
        [
            550,
            310,
            1
        ],
        [
            550,
            310,
            1
        ],
        [
            550,
            315,
            1
        ],
        [
            545,
            315,
            1
        ],
        [
            545,
            320,
            1
        ],
        [
            545,
            325,
            1
        ],
        [
            545,
            330,
            1
        ],
        [
            545,
            330,
            1
        ],
        [
            545,
            335,
            1
        ],
        [
            540,
            340,
            1
        ],
        [
            540,
            340,
            1
        ],
        [
            510,
            215,
            1
        ],
        [
            510,
            215,
            1
        ],
        [
            525,
            350,
            1
        ],
        [
            480,
            220,
            1
        ],
        [
            480,
            220,
            1
        ],
        [
            480,
            220,
            1
        ],
        [
            480,
            220,
            1
        ],
        [
            480,
            220,
            1
        ],
        [
            480,
            225,
            1
        ],
        [
            480,
            225,
            1
        ],
        [
            480,
            225,
            1
        ],
        [
            480,
            325,
            1
        ],
        [
            400,
            420,
            1
        ],
        [
            400,
            420,
            1
        ],
        [
            400,
            420,
            1
        ],
        [
            400,
            425,
            1
        ],
        [
            385,
            435,
            1
        ],
        [
            385,
            440,
            1
        ],
        [
            410,
            230,
            1
        ],
        [
            380,
            230,
            1
        ],
        [
            380,
            230,
            1
        ],
        [
            375,
            230,
            1
        ],
        [
            370,
            230,
            1
        ],
        [
            365,
            230,
            1
        ],
        [
            365,
            230,
            1
        ],
        [
            360,
            230,
            1
        ],
        [
            355,
            235,
            1
        ],
        [
            350,
            235,
            1
        ],
        [
            350,
            235,
            1
        ],
        [
            335,
            245,
            1
        ],
        [
            375,
            345,
            1
        ],
        [
            375,
            350,
            1
        ],
        [
            375,
            350,
            1
        ],
        [
            375,
            350,
            1
        ]
    ],
    CB: [
        [
            510,
            955,
            1
        ],
        [
            515,
            955,
            1
        ],
        [
            540,
            945,
            1
        ],
        [
            545,
            945,
            1
        ],
        [
            550,
            940,
            1
        ],
        [
            620,
            910,
            1
        ],
        [
            475,
            955,
            1
        ],
        [
            475,
            955,
            1
        ],
        [
            495,
            900,
            1
        ],
        [
            495,
            895,
            1
        ],
        [
            495,
            895,
            1
        ],
        [
            495,
            890,
            1
        ],
        [
            495,
            890,
            1
        ],
        [
            495,
            890,
            1
        ],
        [
            495,
            890,
            1
        ],
        [
            495,
            885,
            1
        ],
        [
            495,
            885,
            1
        ],
        [
            500,
            885,
            1
        ],
        [
            500,
            880,
            1
        ],
        [
            500,
            880,
            1
        ],
        [
            590,
            940,
            1
        ],
        [
            600,
            925,
            1
        ],
        [
            600,
            925,
            1
        ],
        [
            600,
            925,
            1
        ],
        [
            600,
            920,
            1
        ],
        [
            600,
            920,
            1
        ],
        [
            600,
            920,
            1
        ],
        [
            605,
            915,
            1
        ],
        [
            605,
            915,
            1
        ],
        [
            605,
            915,
            1
        ],
        [
            605,
            910,
            1
        ],
        [
            605,
            910,
            1
        ],
        [
            605,
            910,
            1
        ],
        [
            605,
            905,
            1
        ],
        [
            645,
            940,
            1
        ],
        [
            645,
            940,
            1
        ],
        [
            650,
            925,
            1
        ],
        [
            655,
            905,
            1
        ],
        [
            655,
            905,
            1
        ],
        [
            655,
            900,
            1
        ],
        [
            660,
            880,
            1
        ],
        [
            710,
            850,
            1
        ],
        [
            710,
            850,
            1
        ],
        [
            730,
            835,
            1
        ],
        [
            550,
            810,
            1
        ],
        [
            550,
            810,
            1
        ],
        [
            550,
            810,
            1
        ],
        [
            550,
            810,
            1
        ],
        [
            550,
            810,
            1
        ],
        [
            550,
            810,
            1
        ],
        [
            550,
            810,
            1
        ],
        [
            555,
            810,
            1
        ],
        [
            565,
            810,
            1
        ],
        [
            770,
            860,
            1
        ],
        [
            775,
            860,
            1
        ],
        [
            775,
            855,
            1
        ],
        [
            775,
            855,
            1
        ],
        [
            775,
            855,
            1
        ],
        [
            445,
            945,
            1
        ],
        [
            445,
            945,
            1
        ],
        [
            440,
            940,
            1
        ],
        [
            275,
            835,
            1
        ],
        [
            275,
            835,
            1
        ],
        [
            275,
            835,
            1
        ],
        [
            325,
            880,
            1
        ],
        [
            325,
            880,
            1
        ],
        [
            325,
            880,
            1
        ],
        [
            355,
            855,
            1
        ],
        [
            355,
            855,
            1
        ],
        [
            355,
            855,
            1
        ],
        [
            415,
            775,
            1
        ],
        [
            415,
            775,
            1
        ],
        [
            415,
            775,
            1
        ],
        [
            440,
            770,
            1
        ],
        [
            440,
            770,
            1
        ],
        [
            440,
            770,
            1
        ],
        [
            420,
            790,
            1
        ],
        [
            420,
            790,
            1
        ],
        [
            415,
            870,
            1
        ],
        [
            415,
            870,
            1
        ],
        [
            415,
            870,
            1
        ],
        [
            415,
            870,
            1
        ],
        [
            485,
            870,
            1
        ],
        [
            485,
            870,
            1
        ],
        [
            490,
            870,
            1
        ],
        [
            490,
            870,
            1
        ],
        [
            490,
            870,
            1
        ],
        [
            590,
            900,
            1
        ],
        [
            590,
            900,
            1
        ],
        [
            350,
            980,
            1
        ],
        [
            350,
            980,
            1
        ],
        [
            340,
            960,
            1
        ],
        [
            340,
            960,
            1
        ],
        [
            345,
            960,
            1
        ],
        [
            335,
            765,
            1
        ],
        [
            335,
            765,
            1
        ],
        [
            335,
            760,
            1
        ],
        [
            335,
            760,
            1
        ],
        [
            460,
            740,
            1
        ],
        [
            460,
            740,
            1
        ],
        [
            465,
            735,
            1
        ],
        [
            545,
            755,
            1
        ],
        [
            545,
            755,
            1
        ],
        [
            545,
            750,
            1
        ],
        [
            620,
            800,
            1
        ],
        [
            625,
            800,
            1
        ],
        [
            625,
            800,
            1
        ],
        [
            625,
            800,
            1
        ],
        [
            625,
            800,
            1
        ],
        [
            750,
            845,
            1
        ],
        [
            750,
            840,
            1
        ],
        [
            675,
            815,
            1
        ],
        [
            670,
            815,
            1
        ],
        [
            670,
            815,
            1
        ],
        [
            670,
            815,
            1
        ],
        [
            670,
            815,
            1
        ],
        [
            555,
            920,
            1
        ],
        [
            555,
            915,
            1
        ],
        [
            555,
            915,
            1
        ],
        [
            515,
            915,
            1
        ],
        [
            520,
            915,
            1
        ],
        [
            505,
            935,
            1
        ],
        [
            505,
            935,
            1
        ]
    ],
    CF: [
        [
            495,
            205,
            1
        ],
        [
            500,
            205,
            1
        ],
        [
            500,
            205,
            1
        ],
        [
            500,
            205,
            1
        ],
        [
            500,
            200,
            1
        ],
        [
            500,
            200,
            1
        ],
        [
            500,
            195,
            1
        ],
        [
            490,
            195,
            1
        ],
        [
            485,
            195,
            1
        ],
        [
            490,
            195,
            1
        ],
        [
            490,
            200,
            1
        ],
        [
            495,
            200,
            1
        ],
        [
            505,
            195,
            1
        ],
        [
            505,
            195,
            1
        ],
        [
            505,
            190,
            1
        ],
        [
            505,
            190,
            1
        ],
        [
            530,
            175,
            1
        ],
        [
            535,
            170,
            1
        ],
        [
            545,
            165,
            1
        ],
        [
            555,
            160,
            1
        ],
        [
            555,
            155,
            1
        ],
        [
            555,
            155,
            1
        ],
        [
            555,
            155,
            1
        ],
        [
            560,
            155,
            1
        ],
        [
            565,
            150,
            1
        ],
        [
            565,
            150,
            1
        ],
        [
            570,
            150,
            1
        ],
        [
            575,
            145,
            1
        ],
        [
            580,
            140,
            1
        ],
        [
            495,
            255,
            1
        ],
        [
            495,
            255,
            1
        ],
        [
            495,
            260,
            1
        ],
        [
            485,
            265,
            1
        ],
        [
            485,
            270,
            1
        ],
        [
            485,
            270,
            1
        ],
        [
            485,
            270,
            1
        ],
        [
            465,
            280,
            1
        ],
        [
            465,
            280,
            1
        ],
        [
            460,
            280,
            1
        ],
        [
            450,
            290,
            1
        ],
        [
            445,
            290,
            1
        ],
        [
            445,
            290,
            1
        ],
        [
            430,
            295,
            1
        ],
        [
            415,
            295,
            1
        ],
        [
            395,
            295,
            1
        ],
        [
            480,
            330,
            1
        ],
        [
            480,
            335,
            1
        ],
        [
            490,
            335,
            1
        ],
        [
            610,
            320,
            1
        ],
        [
            610,
            320,
            1
        ],
        [
            625,
            305,
            1
        ],
        [
            630,
            305,
            1
        ],
        [
            635,
            305,
            1
        ],
        [
            640,
            295,
            1
        ],
        [
            650,
            390,
            1
        ],
        [
            650,
            390,
            1
        ],
        [
            650,
            385,
            1
        ],
        [
            650,
            385,
            1
        ],
        [
            650,
            385,
            1
        ],
        [
            645,
            385,
            1
        ],
        [
            645,
            385,
            1
        ],
        [
            645,
            385,
            1
        ],
        [
            645,
            385,
            1
        ],
        [
            645,
            385,
            1
        ],
        [
            635,
            375,
            1
        ],
        [
            630,
            375,
            1
        ],
        [
            625,
            375,
            1
        ],
        [
            560,
            320,
            1
        ],
        [
            555,
            315,
            1
        ],
        [
            545,
            315,
            1
        ],
        [
            540,
            310,
            1
        ],
        [
            540,
            305,
            1
        ],
        [
            540,
            305,
            1
        ],
        [
            590,
            370,
            1
        ],
        [
            585,
            370,
            1
        ],
        [
            585,
            370,
            1
        ],
        [
            520,
            345,
            1
        ],
        [
            520,
            345,
            1
        ],
        [
            520,
            340,
            1
        ],
        [
            520,
            340,
            1
        ],
        [
            660,
            265,
            1
        ],
        [
            660,
            265,
            1
        ],
        [
            645,
            260,
            1
        ],
        [
            645,
            260,
            1
        ],
        [
            640,
            260,
            1
        ],
        [
            630,
            250,
            1
        ],
        [
            625,
            245,
            1
        ],
        [
            620,
            245,
            1
        ],
        [
            630,
            240,
            1
        ],
        [
            630,
            240,
            1
        ],
        [
            640,
            215,
            1
        ],
        [
            640,
            215,
            1
        ],
        [
            640,
            210,
            1
        ],
        [
            625,
            240,
            1
        ],
        [
            625,
            235,
            1
        ],
        [
            615,
            230,
            1
        ],
        [
            610,
            230,
            1
        ],
        [
            610,
            230,
            1
        ],
        [
            610,
            230,
            1
        ],
        [
            610,
            230,
            1
        ],
        [
            610,
            235,
            1
        ],
        [
            615,
            265,
            1
        ],
        [
            615,
            265,
            1
        ],
        [
            615,
            265,
            1
        ],
        [
            615,
            265,
            1
        ],
        [
            605,
            280,
            1
        ],
        [
            605,
            280,
            1
        ],
        [
            605,
            280,
            1
        ],
        [
            605,
            285,
            1
        ],
        [
            600,
            285,
            1
        ],
        [
            600,
            285,
            1
        ],
        [
            600,
            280,
            1
        ],
        [
            600,
            280,
            1
        ],
        [
            575,
            275,
            1
        ],
        [
            560,
            275,
            1
        ],
        [
            600,
            315,
            1
        ],
        [
            600,
            315,
            1
        ],
        [
            595,
            315,
            1
        ],
        [
            595,
            315,
            1
        ],
        [
            595,
            315,
            1
        ],
        [
            595,
            315,
            1
        ],
        [
            540,
            295,
            1
        ],
        [
            540,
            295,
            1
        ],
        [
            540,
            290,
            1
        ],
        [
            535,
            290,
            1
        ],
        [
            535,
            290,
            1
        ],
        [
            535,
            290,
            1
        ],
        [
            535,
            290,
            1
        ],
        [
            530,
            290,
            1
        ],
        [
            530,
            290,
            1
        ],
        [
            530,
            290,
            1
        ],
        [
            525,
            290,
            1
        ],
        [
            525,
            290,
            1
        ],
        [
            500,
            275,
            1
        ],
        [
            500,
            275,
            1
        ],
        [
            500,
            265,
            1
        ],
        [
            500,
            260,
            1
        ],
        [
            535,
            250,
            1
        ],
        [
            535,
            250,
            1
        ],
        [
            540,
            250,
            1
        ],
        [
            555,
            245,
            1
        ],
        [
            560,
            240,
            1
        ],
        [
            560,
            215,
            1
        ],
        [
            560,
            215,
            1
        ],
        [
            555,
            210,
            1
        ],
        [
            555,
            210,
            1
        ],
        [
            555,
            210,
            1
        ],
        [
            555,
            210,
            1
        ],
        [
            595,
            245,
            1
        ],
        [
            595,
            245,
            1
        ],
        [
            575,
            215,
            1
        ],
        [
            570,
            215,
            1
        ],
        [
            570,
            215,
            1
        ],
        [
            570,
            210,
            1
        ],
        [
            565,
            210,
            1
        ],
        [
            565,
            205,
            1
        ],
        [
            545,
            190,
            1
        ],
        [
            560,
            210,
            1
        ],
        [
            560,
            210,
            1
        ],
        [
            560,
            210,
            1
        ],
        [
            560,
            215,
            1
        ],
        [
            565,
            215,
            1
        ],
        [
            590,
            250,
            1
        ],
        [
            590,
            255,
            1
        ],
        [
            600,
            265,
            1
        ],
        [
            570,
            275,
            1
        ],
        [
            550,
            265,
            1
        ],
        [
            550,
            265,
            1
        ],
        [
            550,
            270,
            1
        ],
        [
            550,
            270,
            1
        ],
        [
            550,
            270,
            1
        ],
        [
            550,
            275,
            1
        ],
        [
            555,
            275,
            1
        ],
        [
            555,
            275,
            1
        ],
        [
            555,
            275,
            1
        ],
        [
            560,
            280,
            1
        ],
        [
            560,
            280,
            1
        ],
        [
            580,
            300,
            1
        ],
        [
            580,
            300,
            1
        ],
        [
            585,
            300,
            1
        ],
        [
            585,
            295,
            1
        ]
    ],
    SW: [
        [
            505,
            1090,
            1
        ],
        [
            505,
            1090,
            1
        ],
        [
            510,
            1090,
            1
        ],
        [
            510,
            1090,
            1
        ],
        [
            520,
            1090,
            1
        ],
        [
            535,
            1085,
            1
        ],
        [
            535,
            1085,
            1
        ],
        [
            535,
            1085,
            1
        ],
        [
            470,
            1120,
            1
        ],
        [
            455,
            1110,
            1
        ],
        [
            455,
            1110,
            1
        ],
        [
            445,
            1110,
            1
        ],
        [
            430,
            1105,
            1
        ],
        [
            435,
            1095,
            1
        ],
        [
            435,
            1095,
            1
        ],
        [
            425,
            1075,
            1
        ],
        [
            415,
            1050,
            1
        ],
        [
            415,
            1045,
            1
        ],
        [
            410,
            1045,
            1
        ],
        [
            410,
            1080,
            1
        ],
        [
            400,
            1065,
            1
        ],
        [
            400,
            1065,
            1
        ],
        [
            400,
            1060,
            1
        ],
        [
            400,
            1060,
            1
        ],
        [
            375,
            1030,
            1
        ],
        [
            375,
            1030,
            1
        ],
        [
            375,
            1030,
            1
        ],
        [
            375,
            1030,
            1
        ],
        [
            350,
            990,
            1
        ],
        [
            345,
            985,
            1
        ],
        [
            340,
            980,
            1
        ],
        [
            565,
            1090,
            1
        ],
        [
            565,
            1090,
            1
        ],
        [
            640,
            1080,
            1
        ],
        [
            645,
            1080,
            1
        ],
        [
            645,
            1080,
            1
        ],
        [
            645,
            1080,
            1
        ],
        [
            650,
            1080,
            1
        ],
        [
            655,
            1080,
            1
        ],
        [
            655,
            1075,
            1
        ],
        [
            710,
            1055,
            1
        ],
        [
            710,
            1050,
            1
        ],
        [
            710,
            1050,
            1
        ],
        [
            710,
            1050,
            1
        ],
        [
            715,
            1050,
            1
        ],
        [
            715,
            1050,
            1
        ],
        [
            715,
            1050,
            1
        ],
        [
            715,
            1050,
            1
        ],
        [
            720,
            1050,
            1
        ],
        [
            550,
            1070,
            1
        ],
        [
            550,
            1070,
            1
        ],
        [
            540,
            1065,
            1
        ],
        [
            540,
            1065,
            1
        ],
        [
            540,
            1060,
            1
        ],
        [
            540,
            1060,
            1
        ],
        [
            525,
            1040,
            1
        ],
        [
            525,
            1040,
            1
        ],
        [
            525,
            1040,
            1
        ],
        [
            525,
            1035,
            1
        ],
        [
            525,
            1035,
            1
        ],
        [
            515,
            1010,
            1
        ],
        [
            610,
            1035,
            1
        ],
        [
            610,
            1035,
            1
        ],
        [
            635,
            985,
            1
        ],
        [
            585,
            1005,
            1
        ],
        [
            580,
            985,
            1
        ],
        [
            550,
            970,
            1
        ],
        [
            550,
            970,
            1
        ],
        [
            550,
            970,
            1
        ],
        [
            550,
            970,
            1
        ],
        [
            545,
            965,
            1
        ],
        [
            450,
            1000,
            1
        ],
        [
            445,
            1000,
            1
        ],
        [
            430,
            995,
            1
        ],
        [
            430,
            995,
            1
        ],
        [
            425,
            995,
            1
        ],
        [
            635,
            1000,
            1
        ],
        [
            635,
            1000,
            1
        ],
        [
            640,
            1000,
            1
        ],
        [
            655,
            1015,
            1
        ],
        [
            655,
            1000,
            1
        ],
        [
            645,
            985,
            1
        ],
        [
            475,
            995,
            1
        ],
        [
            475,
            995,
            1
        ],
        [
            475,
            995,
            1
        ],
        [
            485,
            975,
            1
        ],
        [
            350,
            1110,
            1
        ],
        [
            345,
            1115,
            1
        ],
        [
            340,
            1125,
            1
        ],
        [
            355,
            1145,
            1
        ],
        [
            355,
            1150,
            1
        ],
        [
            345,
            1150,
            1
        ],
        [
            320,
            1160,
            1
        ],
        [
            310,
            1160,
            1
        ],
        [
            310,
            1160,
            1
        ],
        [
            300,
            1165,
            1
        ],
        [
            300,
            1165,
            1
        ],
        [
            305,
            1110,
            1
        ],
        [
            305,
            1110,
            1
        ],
        [
            335,
            1095,
            1
        ],
        [
            330,
            1100,
            1
        ],
        [
            325,
            1100,
            1
        ],
        [
            260,
            1125,
            1
        ],
        [
            260,
            1125,
            1
        ],
        [
            260,
            1130,
            1
        ],
        [
            250,
            1135,
            1
        ],
        [
            205,
            1080,
            1
        ],
        [
            205,
            1080,
            1
        ],
        [
            260,
            1035,
            1
        ],
        [
            260,
            1035,
            1
        ],
        [
            260,
            1035,
            1
        ],
        [
            290,
            1005,
            1
        ],
        [
            290,
            1005,
            1
        ],
        [
            245,
            1115,
            1
        ],
        [
            245,
            1115,
            1
        ]
    ],
    GK: [
        [
            465,
            1145,
            1
        ],
        [
            465,
            1160,
            1
        ],
        [
            465,
            1160,
            1
        ],
        [
            465,
            1165,
            1
        ],
        [
            465,
            1165,
            1
        ],
        [
            465,
            1165,
            1
        ],
        [
            465,
            1165,
            1
        ],
        [
            465,
            1170,
            1
        ],
        [
            465,
            1170,
            1
        ],
        [
            470,
            1170,
            1
        ],
        [
            470,
            1175,
            1
        ],
        [
            510,
            1200,
            1
        ],
        [
            500,
            1195,
            1
        ],
        [
            495,
            1210,
            1
        ],
        [
            495,
            1210,
            1
        ],
        [
            500,
            1195,
            1
        ],
        [
            515,
            1195,
            1
        ],
        [
            520,
            1185,
            1
        ],
        [
            520,
            1185,
            1
        ],
        [
            520,
            1185,
            1
        ],
        [
            520,
            1185,
            1
        ],
        [
            530,
            1155,
            1
        ],
        [
            575,
            1165,
            1
        ],
        [
            595,
            1145,
            1
        ],
        [
            600,
            1145,
            1
        ],
        [
            600,
            1140,
            1
        ],
        [
            605,
            1140,
            1
        ],
        [
            605,
            1135,
            1
        ],
        [
            605,
            1135,
            1
        ],
        [
            620,
            1110,
            1
        ],
        [
            635,
            1125,
            1
        ],
        [
            590,
            1170,
            1
        ],
        [
            590,
            1170,
            1
        ],
        [
            590,
            1145,
            1
        ],
        [
            590,
            1140,
            1
        ],
        [
            590,
            1140,
            1
        ],
        [
            590,
            1135,
            1
        ],
        [
            590,
            1135,
            1
        ],
        [
            595,
            1050,
            1
        ],
        [
            595,
            1050,
            1
        ],
        [
            595,
            1045,
            1
        ],
        [
            595,
            1045,
            1
        ],
        [
            595,
            1045,
            1
        ],
        [
            595,
            1040,
            1
        ],
        [
            595,
            1040,
            1
        ],
        [
            595,
            1035,
            1
        ],
        [
            490,
            1170,
            1
        ],
        [
            435,
            1145,
            1
        ],
        [
            430,
            1145,
            1
        ],
        [
            425,
            1140,
            1
        ],
        [
            420,
            1140,
            1
        ],
        [
            420,
            1140,
            1
        ],
        [
            415,
            1135,
            1
        ],
        [
            415,
            1135,
            1
        ],
        [
            410,
            1135,
            1
        ],
        [
            410,
            1135,
            1
        ],
        [
            405,
            1130,
            1
        ],
        [
            405,
            1130,
            1
        ],
        [
            400,
            1130,
            1
        ],
        [
            400,
            1125,
            1
        ],
        [
            395,
            1125,
            1
        ],
        [
            390,
            1120,
            1
        ],
        [
            365,
            1110,
            1
        ],
        [
            370,
            1075,
            1
        ],
        [
            370,
            1075,
            1
        ],
        [
            345,
            1050,
            1
        ],
        [
            330,
            1045,
            1
        ],
        [
            505,
            1105,
            1
        ],
        [
            505,
            1105,
            1
        ],
        [
            510,
            1105,
            1
        ],
        [
            510,
            1105,
            1
        ],
        [
            510,
            1105,
            1
        ],
        [
            510,
            1105,
            1
        ],
        [
            515,
            1105,
            1
        ],
        [
            515,
            1105,
            1
        ],
        [
            555,
            1105,
            1
        ],
        [
            560,
            1105,
            1
        ],
        [
            560,
            1105,
            1
        ],
        [
            560,
            1105,
            1
        ],
        [
            560,
            1105,
            1
        ],
        [
            560,
            1105,
            1
        ],
        [
            565,
            1105,
            1
        ],
        [
            565,
            1105,
            1
        ],
        [
            565,
            1105,
            1
        ],
        [
            565,
            1105,
            1
        ],
        [
            570,
            1105,
            1
        ],
        [
            520,
            1035,
            1
        ],
        [
            520,
            1035,
            1
        ],
        [
            495,
            1030,
            1
        ],
        [
            435,
            1030,
            1
        ],
        [
            435,
            1030,
            1
        ],
        [
            435,
            1030,
            1
        ],
        [
            400,
            1045,
            1
        ],
        [
            390,
            1210,
            1
        ],
        [
            390,
            1210,
            1
        ],
        [
            390,
            1210,
            1
        ],
        [
            390,
            1210,
            1
        ],
        [
            395,
            1210,
            1
        ],
        [
            395,
            1210,
            1
        ],
        [
            415,
            1215,
            1
        ],
        [
            415,
            1215,
            1
        ],
        [
            415,
            1215,
            1
        ],
        [
            420,
            1215,
            1
        ],
        [
            420,
            1215,
            1
        ],
        [
            450,
            1220,
            1
        ],
        [
            445,
            1225,
            1
        ],
        [
            445,
            1225,
            1
        ],
        [
            450,
            1225,
            1
        ],
        [
            495,
            1215,
            1
        ],
        [
            495,
            1215,
            1
        ],
        [
            495,
            1215,
            1
        ],
        [
            500,
            1215,
            1
        ],
        [
            500,
            1215,
            1
        ],
        [
            505,
            1215,
            1
        ],
        [
            505,
            1215,
            1
        ],
        [
            505,
            1215,
            1
        ],
        [
            510,
            1215,
            1
        ],
        [
            525,
            1210,
            1
        ],
        [
            650,
            1175,
            1
        ],
        [
            640,
            1155,
            1
        ],
        [
            655,
            1130,
            1
        ],
        [
            655,
            1130,
            1
        ],
        [
            660,
            1130,
            1
        ],
        [
            660,
            1130,
            1
        ],
        [
            660,
            1130,
            1
        ],
        [
            660,
            1125,
            1
        ],
        [
            720,
            1075,
            1
        ],
        [
            720,
            1075,
            1
        ],
        [
            720,
            1075,
            1
        ],
        [
            705,
            995,
            1
        ],
        [
            595,
            940,
            1
        ],
        [
            595,
            940,
            1
        ],
        [
            530,
            950,
            1
        ],
        [
            530,
            950,
            1
        ],
        [
            530,
            955,
            1
        ],
        [
            530,
            955,
            1
        ],
        [
            505,
            960,
            1
        ],
        [
            505,
            960,
            1
        ],
        [
            505,
            960,
            1
        ],
        [
            500,
            960,
            1
        ],
        [
            455,
            975,
            1
        ],
        [
            380,
            985,
            1
        ],
        [
            380,
            985,
            1
        ],
        [
            365,
            990,
            1
        ],
        [
            275,
            1015,
            1
        ],
        [
            275,
            1020,
            1
        ],
        [
            275,
            1020,
            1
        ],
        [
            275,
            1020,
            1
        ],
        [
            270,
            1020,
            1
        ],
        [
            270,
            1020,
            1
        ],
        [
            270,
            1020,
            1
        ],
        [
            265,
            1030,
            1
        ],
        [
            260,
            1100,
            1
        ],
        [
            260,
            1100,
            1
        ],
        [
            265,
            1110,
            1
        ],
        [
            265,
            1110,
            1
        ],
        [
            265,
            1110,
            1
        ],
        [
            265,
            1110,
            1
        ],
        [
            275,
            1165,
            1
        ],
        [
            275,
            1165,
            1
        ],
        [
            280,
            1165,
            1
        ],
        [
            280,
            1165,
            1
        ],
        [
            280,
            1170,
            1
        ],
        [
            280,
            1175,
            1
        ],
        [
            305,
            1195,
            1
        ],
        [
            305,
            1195,
            1
        ],
        [
            310,
            1195,
            1
        ],
        [
            310,
            1195,
            1
        ],
        [
            320,
            1205,
            1
        ],
        [
            350,
            1240,
            1
        ],
        [
            350,
            1240,
            1
        ],
        [
            355,
            1240,
            1
        ],
        [
            355,
            1240,
            1
        ],
        [
            695,
            1175,
            1
        ],
        [
            695,
            1175,
            1
        ],
        [
            695,
            1175,
            1
        ],
        [
            690,
            1170,
            1
        ],
        [
            685,
            1165,
            1
        ],
        [
            665,
            1015,
            1
        ],
        [
            665,
            1015,
            1
        ],
        [
            665,
            1015,
            1
        ],
        [
            660,
            1015,
            1
        ],
        [
            660,
            1015,
            1
        ],
        [
            655,
            1015,
            1
        ],
        [
            510,
            950,
            1
        ],
        [
            335,
            945,
            1
        ],
        [
            335,
            945,
            1
        ],
        [
            335,
            950,
            1
        ],
        [
            410,
            1030,
            1
        ],
        [
            440,
            995,
            1
        ],
        [
            440,
            995,
            1
        ],
        [
            440,
            995,
            1
        ],
        [
            640,
            1220,
            1
        ],
        [
            640,
            1220,
            1
        ],
        [
            640,
            1215,
            1
        ],
        [
            635,
            1240,
            1
        ],
        [
            635,
            1240,
            1
        ],
        [
            675,
            1245,
            1
        ],
        [
            675,
            1245,
            1
        ],
        [
            675,
            1240,
            1
        ],
        [
            580,
            1250,
            1
        ],
        [
            580,
            1250,
            1
        ]
    ],
    LWB: [
        [
            145,
            870,
            1
        ],
        [
            145,
            870,
            1
        ],
        [
            145,
            870,
            1
        ],
        [
            145,
            870,
            1
        ],
        [
            145,
            870,
            1
        ],
        [
            145,
            865,
            1
        ],
        [
            145,
            865,
            1
        ],
        [
            150,
            865,
            1
        ],
        [
            150,
            850,
            1
        ],
        [
            145,
            845,
            1
        ],
        [
            145,
            850,
            1
        ],
        [
            160,
            855,
            1
        ],
        [
            160,
            855,
            1
        ],
        [
            165,
            860,
            1
        ],
        [
            225,
            860,
            1
        ],
        [
            225,
            860,
            1
        ],
        [
            225,
            855,
            1
        ],
        [
            235,
            855,
            1
        ],
        [
            235,
            855,
            1
        ],
        [
            245,
            845,
            1
        ],
        [
            250,
            830,
            1
        ],
        [
            250,
            830,
            1
        ],
        [
            260,
            805,
            1
        ],
        [
            260,
            805,
            1
        ],
        [
            260,
            805,
            1
        ],
        [
            255,
            805,
            1
        ],
        [
            240,
            805,
            1
        ],
        [
            240,
            805,
            1
        ],
        [
            240,
            805,
            1
        ],
        [
            240,
            800,
            1
        ],
        [
            220,
            795,
            1
        ],
        [
            185,
            775,
            1
        ],
        [
            180,
            775,
            1
        ],
        [
            180,
            775,
            1
        ],
        [
            180,
            775,
            1
        ],
        [
            170,
            770,
            1
        ],
        [
            135,
            795,
            1
        ],
        [
            130,
            795,
            1
        ],
        [
            130,
            795,
            1
        ],
        [
            130,
            795,
            1
        ],
        [
            130,
            795,
            1
        ],
        [
            130,
            795,
            1
        ],
        [
            90,
            810,
            1
        ],
        [
            90,
            810,
            1
        ],
        [
            90,
            815,
            1
        ],
        [
            90,
            815,
            1
        ],
        [
            85,
            815,
            1
        ],
        [
            70,
            840,
            1
        ],
        [
            65,
            840,
            1
        ],
        [
            65,
            845,
            1
        ],
        [
            65,
            845,
            1
        ],
        [
            65,
            860,
            1
        ],
        [
            65,
            860,
            1
        ],
        [
            120,
            905,
            1
        ],
        [
            120,
            905,
            1
        ],
        [
            120,
            905,
            1
        ],
        [
            155,
            900,
            1
        ],
        [
            160,
            900,
            1
        ],
        [
            160,
            900,
            1
        ],
        [
            160,
            900,
            1
        ],
        [
            160,
            900,
            1
        ],
        [
            165,
            900,
            1
        ],
        [
            165,
            900,
            1
        ],
        [
            175,
            900,
            1
        ],
        [
            285,
            885,
            1
        ],
        [
            290,
            885,
            1
        ],
        [
            295,
            875,
            1
        ],
        [
            295,
            870,
            1
        ],
        [
            295,
            870,
            1
        ],
        [
            300,
            865,
            1
        ],
        [
            180,
            705,
            1
        ],
        [
            180,
            705,
            1
        ],
        [
            85,
            685,
            1
        ],
        [
            85,
            685,
            1
        ],
        [
            85,
            685,
            1
        ],
        [
            120,
            670,
            1
        ],
        [
            120,
            670,
            1
        ],
        [
            145,
            670,
            1
        ],
        [
            185,
            660,
            1
        ],
        [
            205,
            665,
            1
        ],
        [
            205,
            665,
            1
        ],
        [
            265,
            695,
            1
        ],
        [
            265,
            695,
            1
        ],
        [
            275,
            695,
            1
        ],
        [
            275,
            700,
            1
        ],
        [
            310,
            700,
            1
        ],
        [
            315,
            760,
            1
        ],
        [
            320,
            760,
            1
        ],
        [
            355,
            790,
            1
        ],
        [
            355,
            790,
            1
        ],
        [
            355,
            790,
            1
        ],
        [
            360,
            795,
            1
        ],
        [
            355,
            890,
            1
        ],
        [
            355,
            890,
            1
        ],
        [
            360,
            890,
            1
        ],
        [
            360,
            915,
            1
        ],
        [
            360,
            915,
            1
        ],
        [
            355,
            915,
            1
        ],
        [
            355,
            920,
            1
        ],
        [
            355,
            920,
            1
        ],
        [
            315,
            955,
            1
        ],
        [
            315,
            955,
            1
        ],
        [
            305,
            960,
            1
        ],
        [
            225,
            965,
            1
        ],
        [
            225,
            965,
            1
        ],
        [
            215,
            970,
            1
        ],
        [
            135,
            990,
            1
        ],
        [
            130,
            990,
            1
        ],
        [
            130,
            990,
            1
        ],
        [
            125,
            990,
            1
        ],
        [
            90,
            1000,
            1
        ],
        [
            80,
            1000,
            1
        ],
        [
            65,
            995,
            1
        ],
        [
            70,
            995,
            1
        ],
        [
            70,
            995,
            1
        ],
        [
            155,
            1030,
            1
        ],
        [
            160,
            1030,
            1
        ],
        [
            290,
            1000,
            1
        ],
        [
            315,
            990,
            1
        ],
        [
            315,
            990,
            1
        ],
        [
            265,
            1000,
            1
        ],
        [
            265,
            1000,
            1
        ],
        [
            265,
            1000,
            1
        ],
        [
            250,
            1005,
            1
        ],
        [
            160,
            1030,
            1
        ],
        [
            155,
            1030,
            1
        ],
        [
            230,
            915,
            1
        ],
        [
            230,
            915,
            1
        ],
        [
            215,
            1035,
            1
        ],
        [
            220,
            1040,
            1
        ]
    ],
    RWB: [
        [
            845,
            875,
            1
        ],
        [
            845,
            875,
            1
        ],
        [
            865,
            875,
            1
        ],
        [
            865,
            875,
            1
        ],
        [
            865,
            875,
            1
        ],
        [
            865,
            860,
            1
        ],
        [
            865,
            855,
            1
        ],
        [
            865,
            855,
            1
        ],
        [
            865,
            855,
            1
        ],
        [
            865,
            850,
            1
        ],
        [
            865,
            850,
            1
        ],
        [
            865,
            850,
            1
        ],
        [
            865,
            850,
            1
        ],
        [
            865,
            850,
            1
        ],
        [
            865,
            845,
            1
        ],
        [
            865,
            845,
            1
        ],
        [
            865,
            845,
            1
        ],
        [
            865,
            840,
            1
        ],
        [
            865,
            825,
            1
        ],
        [
            865,
            820,
            1
        ],
        [
            795,
            780,
            1
        ],
        [
            795,
            775,
            1
        ],
        [
            770,
            760,
            1
        ],
        [
            810,
            820,
            1
        ],
        [
            810,
            820,
            1
        ],
        [
            770,
            800,
            1
        ],
        [
            770,
            800,
            1
        ],
        [
            770,
            800,
            1
        ],
        [
            765,
            800,
            1
        ],
        [
            765,
            795,
            1
        ],
        [
            765,
            795,
            1
        ],
        [
            765,
            795,
            1
        ],
        [
            710,
            770,
            1
        ],
        [
            795,
            750,
            1
        ],
        [
            795,
            745,
            1
        ],
        [
            790,
            700,
            1
        ],
        [
            790,
            700,
            1
        ],
        [
            790,
            695,
            1
        ],
        [
            790,
            695,
            1
        ],
        [
            790,
            690,
            1
        ],
        [
            795,
            690,
            1
        ],
        [
            795,
            690,
            1
        ],
        [
            795,
            685,
            1
        ],
        [
            795,
            685,
            1
        ],
        [
            795,
            685,
            1
        ],
        [
            795,
            680,
            1
        ],
        [
            810,
            665,
            1
        ],
        [
            810,
            665,
            1
        ],
        [
            885,
            760,
            1
        ],
        [
            885,
            765,
            1
        ],
        [
            895,
            765,
            1
        ],
        [
            965,
            805,
            1
        ],
        [
            965,
            805,
            1
        ],
        [
            965,
            810,
            1
        ],
        [
            970,
            810,
            1
        ],
        [
            970,
            810,
            1
        ],
        [
            970,
            810,
            1
        ],
        [
            970,
            815,
            1
        ],
        [
            975,
            815,
            1
        ],
        [
            975,
            815,
            1
        ],
        [
            975,
            815,
            1
        ],
        [
            975,
            815,
            1
        ],
        [
            930,
            745,
            1
        ],
        [
            930,
            745,
            1
        ],
        [
            910,
            695,
            1
        ],
        [
            910,
            695,
            1
        ],
        [
            905,
            695,
            1
        ],
        [
            905,
            690,
            1
        ],
        [
            905,
            685,
            1
        ],
        [
            905,
            680,
            1
        ],
        [
            900,
            680,
            1
        ],
        [
            900,
            675,
            1
        ],
        [
            900,
            675,
            1
        ],
        [
            900,
            675,
            1
        ],
        [
            900,
            670,
            1
        ],
        [
            900,
            670,
            1
        ],
        [
            895,
            670,
            1
        ],
        [
            890,
            655,
            1
        ],
        [
            755,
            835,
            1
        ],
        [
            755,
            835,
            1
        ],
        [
            755,
            860,
            1
        ],
        [
            755,
            865,
            1
        ],
        [
            755,
            865,
            1
        ],
        [
            755,
            865,
            1
        ],
        [
            755,
            880,
            1
        ],
        [
            675,
            830,
            1
        ],
        [
            675,
            830,
            1
        ],
        [
            685,
            835,
            1
        ],
        [
            700,
            770,
            1
        ],
        [
            695,
            760,
            1
        ],
        [
            690,
            755,
            1
        ],
        [
            690,
            750,
            1
        ],
        [
            715,
            735,
            1
        ],
        [
            715,
            710,
            1
        ],
        [
            715,
            705,
            1
        ],
        [
            715,
            705,
            1
        ],
        [
            720,
            695,
            1
        ],
        [
            730,
            670,
            1
        ],
        [
            735,
            665,
            1
        ],
        [
            685,
            595,
            1
        ],
        [
            685,
            595,
            1
        ],
        [
            685,
            600,
            1
        ],
        [
            690,
            600,
            1
        ],
        [
            690,
            600,
            1
        ],
        [
            695,
            610,
            1
        ],
        [
            675,
            630,
            1
        ],
        [
            675,
            630,
            1
        ],
        [
            675,
            640,
            1
        ],
        [
            675,
            640,
            1
        ],
        [
            640,
            740,
            1
        ],
        [
            630,
            755,
            1
        ],
        [
            620,
            770,
            1
        ],
        [
            640,
            830,
            1
        ],
        [
            645,
            830,
            1
        ],
        [
            645,
            830,
            1
        ],
        [
            645,
            835,
            1
        ],
        [
            865,
            940,
            1
        ],
        [
            865,
            940,
            1
        ],
        [
            865,
            940,
            1
        ],
        [
            865,
            945,
            1
        ],
        [
            785,
            905,
            1
        ],
        [
            785,
            905,
            1
        ],
        [
            785,
            910,
            1
        ],
        [
            815,
            785,
            1
        ],
        [
            815,
            785,
            1
        ],
        [
            830,
            770,
            1
        ],
        [
            830,
            770,
            1
        ],
        [
            830,
            770,
            1
        ]
    ],
    REST: [
        [
            200,
            490,
            1
        ],
        [
            200,
            485,
            1
        ],
        [
            200,
            485,
            1
        ],
        [
            200,
            485,
            1
        ],
        [
            200,
            485,
            1
        ],
        [
            200,
            485,
            1
        ],
        [
            205,
            485,
            1
        ],
        [
            205,
            485,
            1
        ],
        [
            205,
            485,
            1
        ],
        [
            205,
            485,
            1
        ],
        [
            210,
            480,
            1
        ],
        [
            210,
            480,
            1
        ],
        [
            210,
            480,
            1
        ],
        [
            220,
            475,
            1
        ],
        [
            220,
            475,
            1
        ],
        [
            225,
            475,
            1
        ],
        [
            225,
            475,
            1
        ],
        [
            225,
            475,
            1
        ],
        [
            235,
            480,
            1
        ],
        [
            240,
            485,
            1
        ],
        [
            240,
            485,
            1
        ],
        [
            245,
            485,
            1
        ],
        [
            245,
            490,
            1
        ],
        [
            245,
            490,
            1
        ],
        [
            250,
            490,
            1
        ],
        [
            250,
            495,
            1
        ],
        [
            315,
            470,
            1
        ],
        [
            305,
            470,
            1
        ],
        [
            335,
            460,
            1
        ],
        [
            340,
            460,
            1
        ],
        [
            410,
            440,
            1
        ],
        [
            410,
            440,
            1
        ],
        [
            415,
            440,
            1
        ],
        [
            435,
            435,
            1
        ],
        [
            445,
            430,
            1
        ],
        [
            445,
            425,
            1
        ],
        [
            445,
            425,
            1
        ],
        [
            445,
            425,
            1
        ],
        [
            305,
            365,
            1
        ],
        [
            305,
            365,
            1
        ],
        [
            305,
            365,
            1
        ],
        [
            305,
            365,
            1
        ],
        [
            265,
            335,
            1
        ],
        [
            265,
            330,
            1
        ],
        [
            265,
            330,
            1
        ],
        [
            265,
            330,
            1
        ],
        [
            265,
            330,
            1
        ],
        [
            265,
            330,
            1
        ],
        [
            260,
            325,
            1
        ],
        [
            260,
            325,
            1
        ],
        [
            260,
            325,
            1
        ],
        [
            260,
            325,
            1
        ],
        [
            260,
            325,
            1
        ],
        [
            255,
            320,
            1
        ],
        [
            255,
            320,
            1
        ],
        [
            240,
            295,
            1
        ],
        [
            235,
            295,
            1
        ],
        [
            235,
            290,
            1
        ],
        [
            410,
            415,
            1
        ],
        [
            410,
            415,
            1
        ],
        [
            425,
            435,
            1
        ],
        [
            425,
            435,
            1
        ],
        [
            425,
            435,
            1
        ],
        [
            425,
            440,
            1
        ],
        [
            425,
            440,
            1
        ],
        [
            430,
            440,
            1
        ],
        [
            430,
            445,
            1
        ],
        [
            430,
            445,
            1
        ],
        [
            430,
            445,
            1
        ],
        [
            430,
            445,
            1
        ],
        [
            440,
            460,
            1
        ],
        [
            345,
            445,
            1
        ],
        [
            345,
            450,
            1
        ],
        [
            345,
            450,
            1
        ],
        [
            345,
            450,
            1
        ],
        [
            345,
            450,
            1
        ],
        [
            345,
            450,
            1
        ],
        [
            345,
            455,
            1
        ],
        [
            340,
            455,
            1
        ],
        [
            340,
            455,
            1
        ],
        [
            340,
            455,
            1
        ],
        [
            330,
            475,
            1
        ],
        [
            325,
            475,
            1
        ],
        [
            270,
            360,
            1
        ],
        [
            270,
            360,
            1
        ],
        [
            280,
            385,
            1
        ],
        [
            285,
            385,
            1
        ],
        [
            295,
            425,
            1
        ],
        [
            300,
            445,
            1
        ],
        [
            280,
            395,
            1
        ],
        [
            280,
            395,
            1
        ],
        [
            285,
            395,
            1
        ],
        [
            285,
            400,
            1
        ],
        [
            285,
            400,
            1
        ],
        [
            285,
            400,
            1
        ],
        [
            395,
            360,
            1
        ],
        [
            410,
            360,
            1
        ],
        [
            415,
            360,
            1
        ],
        [
            445,
            325,
            1
        ],
        [
            445,
            325,
            1
        ],
        [
            445,
            325,
            1
        ],
        [
            485,
            340,
            1
        ],
        [
            485,
            340,
            1
        ],
        [
            490,
            340,
            1
        ],
        [
            495,
            345,
            1
        ],
        [
            410,
            300,
            1
        ],
        [
            410,
            295,
            1
        ],
        [
            445,
            235,
            1
        ],
        [
            400,
            275,
            1
        ],
        [
            400,
            275,
            1
        ],
        [
            360,
            240,
            1
        ],
        [
            380,
            220,
            1
        ],
        [
            340,
            155,
            1
        ],
        [
            335,
            150,
            1
        ],
        [
            335,
            145,
            1
        ],
        [
            330,
            145,
            1
        ],
        [
            330,
            140,
            1
        ],
        [
            230,
            40,
            1
        ],
        [
            365,
            250,
            1
        ],
        [
            365,
            250,
            1
        ],
        [
            315,
            180,
            1
        ],
        [
            310,
            180,
            1
        ],
        [
            310,
            175,
            1
        ],
        [
            305,
            165,
            1
        ],
        [
            285,
            145,
            1
        ],
        [
            290,
            250,
            1
        ],
        [
            290,
            250,
            1
        ],
        [
            235,
            225,
            1
        ],
        [
            230,
            225,
            1
        ],
        [
            225,
            225,
            1
        ],
        [
            225,
            225,
            1
        ],
        [
            220,
            220,
            1
        ],
        [
            220,
            220,
            1
        ],
        [
            215,
            220,
            1
        ],
        [
            215,
            220,
            1
        ],
        [
            210,
            220,
            1
        ],
        [
            155,
            215,
            1
        ],
        [
            335,
            285,
            1
        ],
        [
            335,
            290,
            1
        ],
        [
            370,
            325,
            1
        ],
        [
            370,
            325,
            1
        ],
        [
            375,
            325,
            1
        ],
        [
            375,
            325,
            1
        ],
        [
            375,
            325,
            1
        ]
    ],
};

PitchCanvas.position = (code, width, height) => {
    const {x, y} = positions[code];
    return {x: x * (width ?? 1), y: y * (height ?? 1)};
};
PitchCanvas.tempPosition = (code, width, height) => {
    return tempPositions[code] ?? tempPositions.REST;
};

export default PitchCanvas;
